export enum ActionType
{
    Win,
    SelfWin,
    Kong,
    SelfKong,
    Pong,
    Chow,
    GiveUp
}